import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'outline' | 'ghost' | 'accent' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonStyleOptions {
  variant?: ButtonVariant;
  size?: ButtonSize;
  block?: boolean;
}

/**
 * Devuelve las clases del botón sin renderizar un `<button>`.
 *
 * En el sitio público la mitad de los "botones" son en realidad enlaces
 * (`<Link>` de react-router, `<a href="mailto:...">`). Renderizar un `<button>`
 * con un `onClick` que navega rompe abrir en pestaña nueva y el menú
 * contextual; por eso el estilo se expone aparte y el enlace conserva su
 * etiqueta semántica.
 *
 * Vive en su propio módulo (y no junto al componente) porque un archivo que
 * exporta componentes y utilidades a la vez rompe Fast Refresh.
 */
export function buttonClass({ variant = 'primary', size = 'md', block }: ButtonStyleOptions = {}) {
  return [styles.button, styles[variant], styles[size], block && styles.block]
    .filter(Boolean)
    .join(' ');
}
